/** @format */

import { applyMiddleware, createStore, compose, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { authReducer } from "./reducers/authReducers";
import { categoriesReducer } from "./reducers/categoriesReducers";
import { itemReducer } from "./reducers/itemReducers";
import { orderReducer } from "./reducers/orderReducers";
import { storeReducer } from "./reducers/storeReducers";
import { subCategoriesReducer } from "./reducers/subCategoriesReducers";
import { userReducer } from "./reducers/userReducers";
import { cityReducer } from "./reducers/cityReducers";

const ENVIRONMENT = "local";

const initialState = {
  auth: {
    tokens: localStorage.getItem("tokens")
      ? JSON.parse(localStorage.getItem("tokens"))
      : null,
    user: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null,
    // company: localStorage.getItem("company")
    //   ? JSON.parse(localStorage.getItem("company"))
    //   : null,
    // activeUserCountry: localStorage.getItem("activeUserCountry")
    //   ? JSON.parse(localStorage.getItem("activeUserCountry"))
    //   : null,
    // allUserLoginInActivity: localStorage.getItem("allUserLoginInActivity")
    //   ? JSON.parse(localStorage.getItem("allUserLoginInActivity"))
    //   : null,
    loading: false,
  },
  categories: {
    categories: localStorage.getItem("categories")
      ? JSON.parse(localStorage.getItem("categories"))
      : null,
  },
  subCategories: {
    subCategories: localStorage.getItem("subCategories")
      ? JSON.parse(localStorage.getItem("subCategories"))
      : null,
    groupSubCategories: localStorage.getItem("groupSubCategories")
      ? JSON.parse(localStorage.getItem("groupSubCategories"))
      : null,
  },
  items: {
    items: localStorage.getItem("items")
      ? JSON.parse(localStorage.getItem("items"))
      : null,
  },
  orders: {
    orders: localStorage.getItem("orders")
      ? JSON.parse(localStorage.getItem("orders"))
      : null,
  },
  store: {
    store: localStorage.getItem("store")
      ? JSON.parse(localStorage.getItem("store"))
      : null,
  },
  users: {
    users: localStorage.getItem("users")
      ? JSON.parse(localStorage.getItem("users"))
      : null,
    driver: localStorage.getItem("driver")
      ? JSON.parse(localStorage.getItem("driver"))
      : null,
  },
  city: {
    city: localStorage.getItem("city")
      ? JSON.parse(localStorage.getItem("city"))
      : null,
  },
};

const reducer = combineReducers({
  auth: authReducer,
  categories: categoriesReducer,
  items: itemReducer,
  orders: orderReducer,
  store: storeReducer,
  subCategories: subCategoriesReducer,
  users: userReducer,
  city: cityReducer,
});

const composeEnhancer =
  (ENVIRONMENT === "local" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;
const store = createStore(
  reducer,
  initialState,
  composeEnhancer(applyMiddleware(thunk))
);
export default store;
